import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import api, { timeout } from "../../api"

//PUBLIC STATES
export const getPublicDashboardStates = createAsyncThunk(
  "auth/getPublicDashboardStates",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/auth/v1/states`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      return rejectWithValue(newMessage)
    }
  }
)
//PUBLIC DASHBOARDS
export const getPublicDashboards = createAsyncThunk(
  "auth/getPublicDashboards",
  async ({ state }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/auth/v1/dashboards?state=${state}`)

      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      return rejectWithValue(newMessage)
    }
  }
)

//DONATIONS
export const getPublicDonations = createAsyncThunk(
  "auth/getPublicDonations",
  async ({ disaster, cursor, navigation, pagesize }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/auth/v1/disaster?disaster=${disaster}&cursor=${cursor}&navigation=${navigation}&page-size=${pagesize}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message

      return rejectWithValue(newMessage)
    }
  }
)
//DISASTERS
export const getPublicDisaster = createAsyncThunk(
  "auth/getPublicDisaster",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/auth/v1/disaster`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message

      return rejectWithValue(newMessage)
    }
  }
)
export const getPublicDashboardDropdown = createAsyncThunk(
  "auth/getPublicDashboardDropdown ",
  async ({ dashboard }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/auth/v1/disaster/basic?dashboard=${dashboard}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message

      return rejectWithValue(newMessage)
    }
  }
)
const initialState = {
  disasters: null,
  dashbaords: null,
  data: null,
  loading: false,
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PUBLIC STATES
    builder.addCase(getPublicDashboardStates.pending, (state) => {
      state.loading = true
      state.states = null
    })
    builder.addCase(
      getPublicDashboardStates.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.states = payload.data
      }
    )
    builder.addCase(getPublicDashboardStates.rejected, (state) => {
      state.loading = false
      state.states = null
    })
    // PUBLIC DASHBOARDS
    builder.addCase(getPublicDashboards.pending, (state) => {
      state.loading = true
      state.dashbaords = null
    })
    builder.addCase(getPublicDashboards.fulfilled, (state, { payload }) => {
      state.loading = false
      state.dashbaords = payload.data
    })
    builder.addCase(getPublicDashboards.rejected, (state) => {
      state.loading = false
      state.dashbaords = null
    })
    // PUBLIC DONATIONS
    builder.addCase(getPublicDonations.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(getPublicDonations.fulfilled, (state, { payload }) => {
      state.loading = false
      state.data = payload.data
    })
    builder.addCase(getPublicDonations.rejected, (state) => {
      state.loading = false
      state.data = null
    })

    // PUBLIC DISASTER
    builder.addCase(getPublicDisaster.pending, (state) => {
      state.loading = true
      state.disasters = null
    })
    builder.addCase(getPublicDisaster.fulfilled, (state, { payload }) => {
      state.loading = false
      state.disasters = payload.data
    })
    builder.addCase(getPublicDisaster.rejected, (state) => {
      state.loading = false
      state.disasters = null
    })
    builder.addCase(
      getPublicDashboardDropdown.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.disasters = payload.data
      }
    )
  },
})

export default authSlice.reducer
